import { Alert } from 'antd'
import { store } from 'src/store/configureStore'
import jwtManager from 'src/utils/jwtManager'
import t from 'src/utils/translate'

const state = store.getState()
const defaultHeaders = state.defaultHeaders || {}

export const apiCallHelper = async ({
  request,
  params,
  additionalCall,
  nodeGenerator,
  messageGenerator,
  StatefulNodeComponent
}: {
  request: any
  params: any
  additionalCall?: (data?: any) => void
  nodeGenerator?: (data: any, message: string) => React.ReactNode
  messageGenerator?: (data: any, message: string) => string
  StatefulNodeComponent?: React.FC<{
    data: any
    message: string
  }>
}) => {
  const headers = { ...defaultHeaders, token: jwtManager.getToken() }

  const response = await request(params, headers)

  const { data: res, status: statusCode } = response

  if (statusCode === 200) {
    const { status, message, data } = res.result
    additionalCall && additionalCall(data)

    if (status === 'Failed' || status === 'failed') {
      return {
        node: <Alert type="error" message={message} banner />,
        content: message
      }
    }

    return {
      node: StatefulNodeComponent
        ? <StatefulNodeComponent data={data} message={message} />
        : nodeGenerator
          ? nodeGenerator(data, message)
          : null,
      // node: nodeGenerator ? nodeGenerator(data, message) : null,
      content: messageGenerator ? messageGenerator(data, message) : ``
    }
  } else {
    return {
      node: <Alert type="error" message={res.message} banner />,
      content: `${res.message || t('common.error')}`
    }
  }
}

export const apiCallHelperOld = async ({
  request,
  params,
  additionalCall,
  nodeGenerator,
  messageGenerator
}: {
  request: any
  params: any
  additionalCall?: (data?: any) => void
  nodeGenerator?: (data: any) => React.ReactNode
  messageGenerator?: (data: any) => string
}) => {
  const headers = { ...defaultHeaders, token: jwtManager.getToken() }

  const response = await request(params, headers)

  const { data: res, status: statusCode } = response

  if (statusCode === 200) {
    const { data } = res
    additionalCall && additionalCall(data)

    return {
      node: nodeGenerator ? nodeGenerator(data) : null,
      content: messageGenerator ? messageGenerator(data) : ``
    }
  } else {
    return {
      node: <Alert type="error" message={res.message} banner />,
      content: `${res.message || t('common.error')}`
    }
  }
}

export const responseGenerator = async ({
  data,
  messageGenerator,
  StatefulNodeComponent
}: {
  data: any
  messageGenerator?: (data: any, message: string) => string
  StatefulNodeComponent?: React.FC<{
    data: any
    message?: string
  }>
}) => {
  return {
    node: StatefulNodeComponent
      ? <StatefulNodeComponent data={data} />
        : null,
    content: messageGenerator ? messageGenerator(data, "") : ``
  }
}
